// extracted by mini-css-extract-plugin
export default {"videoUrlExample":"M387rt5u6m","videoUrlExampleParagraph":"kHnAJ5M4A1","videoUrlExampleList":"Wne7kgt6RR"};